import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import * as rt from '../../config/routeType'
import { Grid, Box } from '@mui/material'
import Botton from '.'
import _ from 'lodash'

const COLOR_POPUP = 'var(--color-green)'
const COLOR_PRIMARY = 'var(--color-primary)'
const COLOR_WHITE = '#FFFAFA'
const COLOR_GREY = '#333333'

const gridStyle = {
  mt: 0,
  width: '100%',
  ml: 0,
  textAlignLast: 'right',
  justifyContent: 'space-evenly',
  pr: 2,
}

const styleDefaultButton = (bc, c, bcHover, cHover) => ({
  color: c,
  backgroundColor: bc,
  border: `1px solid ${c}`,
  width: '100%',
  fontSize: '12px',
  '&:hover': { backgroundColor: bcHover, color: cHover },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
})

const BottonInside = ({ isEditable = true, enableButton, hdleButtonCancel }) => {
  const navigate = useNavigate()
  const { specieField, siteField, sectionField, pseudonymField, siteAcronym } =
    useSelector(state => state.treeFeatures.enableSaveButton)
  const errorFields = Boolean(
    specieField.error ||
      pseudonymField.error ||
      siteField.error ||
      siteAcronym.error ||
      sectionField.error
  )
  const emptyField = !Boolean(
    specieField?.selected &&
      pseudonymField?.selected?.length &&
      siteField?.selected &&
      siteAcronym?.selected &&
      sectionField?.selected
  )

  const disableButtonSave = _.isBoolean(enableButton)
    ? !enableButton
    : Boolean(errorFields || emptyField)

  const handleButtonCancel = () => {
    navigate(`/${rt.MANAGEMENT_TREE}/${rt.TREE}`, { replace: false })
  }

  if (!isEditable) return null

  return (
    <Grid container spacing={1} sx={{ ...gridStyle, pr: 1, pb: 1 }}>
      <Grid item xs={12} sm={6}>
        <Box sx={{ width: '100%' }}>
          <Botton
            text="Cancelar"
            onClick={hdleButtonCancel ?? handleButtonCancel}
            variant="contained"
            startIcon={<CancelIcon />}
            styleButton={styleDefaultButton(
              COLOR_WHITE,
              COLOR_GREY,
              COLOR_WHITE,
              COLOR_GREY
            )}
          />
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box sx={{ width: '100%' }}>
          <Botton
            disabled={disableButtonSave}
            text="Guardar"
            type="submit"
            variant="contained"
            startIcon={<CheckCircleIcon />}
            styleButton={styleDefaultButton(
              COLOR_WHITE,
              COLOR_PRIMARY,
              COLOR_WHITE,
              COLOR_POPUP
            )}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default BottonInside
